import Cookies from 'js-cookie';
import {BrowserRouter, Routes, Route, Navigate, useLocation} from 'react-router-dom';

import {User} from './types/user';

import Layout from './containers/layout';
import Home from './containers/home';
import Login from './containers/login';
import Factory from './containers/factory';
import Epics from './containers/epics';
import Epic from './containers/epic';
import List from './containers/list';
import Activities from './containers/activities';
import Activity from './containers/activity';
import isAdmin from './utils/isAdmin';
import ReportPage from './containers/reports';

const RequireAuth = ({children}: any) => {
    const location = useLocation();
    const user: User = JSON.parse(Cookies.get('user') || '{}');
    if (!user?.auth_token) {
        return (
            <Navigate
                to="/login"
                state={{from: location}}
                replace
            />
        );
    }

    return children;
};

const RequireAdmin = ({children}: any) => {
    const location = useLocation();
    const user: User = JSON.parse(Cookies.get('user') || '{}');
    const isUserAdmin = isAdmin(user?.email);
    if (!user?.auth_token && !isUserAdmin) {
        return (
            <Navigate
                to="/login"
                state={{from: location}}
                replace
            />
        );
    }

    return children;
};

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    index
                    path="login"
                    element={<Login/>}
                />
                <Route
                    path="/"
                    element={<Layout/>}
                >
                    <Route
                        path="/"
                        element={
                            <RequireAuth>
                                <Home/>
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="factory"
                        element={
                            <RequireAdmin>
                                <Factory/>
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="epics"
                        element={
                            <RequireAuth>
                                <Epics/>
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="epics/:id"
                        element={
                            <RequireAuth>
                                <Epic/>
                            </RequireAuth>
                        }
                    />
                    <Route
                        path="activities"
                        element={
                            <RequireAdmin>
                                <Activities/>
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="report"
                        element={
                            <RequireAdmin>
                                <ReportPage/>
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="activities/:id/ref/:refid/epic/:epicid"
                        element={
                            <RequireAdmin>
                                <Activity/>
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="epics-srolsnfoapfnkb"
                        element={
                            <RequireAdmin>
                                <List/>
                            </RequireAdmin>
                        }
                    />
                    <Route
                        path="*"
                        element={<div>Not Found</div>}
                    />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
